import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { finalize } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { ESRS, ESRSService } from 'src/app/services/ESRS/esrs.service';
import { Tematica } from 'src/app/services/tematiche/tematiche.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-check-esrs',
  standalone: false,

  templateUrl: './dialog-check-esrs.component.html',
  styleUrl: './dialog-check-esrs.component.scss',
})
export class DialogCheckEsrsComponent implements AfterViewInit {
  @ViewChild('selPanel') selPanel: MatAccordion | undefined;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public esrs: ESRS | undefined = undefined;
  public isEsrsChecked: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogCheckEsrsComponent>,
    private readonly utilityService: UtilityService,
    private readonly esrsService: ESRSService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      domandaTematica: string;
      esrs: ESRS;
      idTematica: string;
    },
  ) {
    /* this.esrs = this.data.esrs */
  }

  ngAfterViewInit(): void {
    this._getEsrsById();
  }

  private _getEsrsById() {
    const idEsrs = this.data.esrs.id;
    const idTematica = this.data.idTematica;

    if (idEsrs && idTematica) {
      this.spinnerOver.show();
      this.esrsService
        .getEsrsById(idEsrs, idTematica)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (esito) => {
            this.esrs = esito;
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
  }

  private _putEsrs() {
    const idEsrs = this.esrs?.id;
    const idTematica = this.data.idTematica;
    if (idTematica && idEsrs && this.esrs) {
      this.spinnerOver.show();
      this.esrsService
        .putEsrsTematica(idEsrs, idTematica, this.esrs)
        .pipe(finalize(() => this.spinnerOver.hide()))
        .subscribe({
          next: (tematica: Tematica) => {
            this.dialogRef.close(tematica);
          },
          error: (err) => {
            console.error(err);
          },
        });
    }
  }

  conferma(): void {
    if (!this.esrs?.selected && !this.checkIfAnyLevelSelected(this.esrs?.sottoTemi)) {
      this.utilityService.openSnackBar('Selezionare almeno un elemento', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });

      return;
    }

    this._putEsrs();
  }

  /**
   * Controllo che almeno un elemento sia stato chekcato prima di salvare
   * @param esrsList lista esrs
   * @returns
   */
  checkIfAnyLevelSelected(esrsList?: ESRS[]): boolean {
    return (
      esrsList?.some((esrs) => esrs.selected || this.checkIfAnyLevelSelected(esrs.sottoTemi)) ??
      false
    );
  }

  onChangeTema(event: MatCheckboxChange) {
    if (this.esrs) {
      const checked: boolean = event.checked;
      this.esrs.selected = checked;
    }
  }

  onChangeSottoTema(event: MatCheckboxChange, sottoTema: ESRS | undefined) {
    if (sottoTema) {
      const checked = event.checked;
      sottoTema.selected = checked;
    }
  }

  onChangeSottoSottoTema(
    event: MatCheckboxChange,
    sottoTema: ESRS | undefined,
    sottoSottoTema: ESRS | undefined,
  ) {
    if (sottoTema && sottoSottoTema) {
      sottoSottoTema.selected = event.checked;
    }
  }

  espandiPanel(esrs: ESRS) {
    if (esrs.selected) {
      return true;
    }
    return false;
  }
}
